import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { 
  signInWithEmailAndPassword, 
  createUserWithEmailAndPassword,
  signInWithPopup,
  GoogleAuthProvider 
} from 'firebase/auth';
import { auth, isDemoMode } from '../firebase/config';
import { FiMail, FiLock, FiGithub } from 'react-icons/fi';
import { FcGoogle } from 'react-icons/fc';

const Login = () => {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [isSignUp, setIsSignUp] = useState(false);
  const [error, setError] = useState('');
  const navigate = useNavigate();

  // Demo mode check
  if (isDemoMode) {
    return (
      <div className="login-container">
        <div className="login-card">
          <h1 className="login-title">🎮 Demo Mode</h1>
          <div style={{ padding: '20px', textAlign: 'center' }}>
            <p style={{ marginBottom: '16px', color: '#757575' }}>
              Firebase is not configured yet. You can still:
            </p>
            <ul style={{ textAlign: 'left', color: '#757575', marginBottom: '24px' }}>
              <li>✅ Explore all topics and content</li>
              <li>✅ View code examples</li>
              <li>✅ Try the code playground</li>
              <li>✅ Take quizzes</li>
              <li>❌ Login/signup (needs Firebase)</li>
              <li>❌ Save progress (needs Firebase)</li>
            </ul>
            <button className="btn btn-primary" onClick={() => navigate('/')}>
              Continue to Learning Portal
            </button>
            <p style={{ marginTop: '16px', fontSize: '14px', color: '#757575' }}>
              To enable authentication, see <strong>SETUP_GUIDE.md</strong>
            </p>
          </div>
        </div>
      </div>
    );
  }

  const handleEmailAuth = async (e) => {
    e.preventDefault();
    setError('');
    
    try {
      if (isSignUp) {
        await createUserWithEmailAndPassword(auth, email, password);
      } else {
        await signInWithEmailAndPassword(auth, email, password);
      }
      navigate('/');
    } catch (err) {
      setError(err.message);
    }
  };

  const handleGoogleSignIn = async () => {
    try {
      const provider = new GoogleAuthProvider();
      await signInWithPopup(auth, provider);
      navigate('/');
    } catch (err) {
      setError(err.message);
    }
  };

  return (
    <div className="login-container">
      <div className="login-card">
        <h1 className="login-title">
          {isSignUp ? 'Join JustDoCode 🚀' : 'Welcome Back! 👋'}
        </h1>
        
        {error && (
          <div style={{ 
            padding: '12px', 
            background: '#ffebee', 
            color: '#c62828', 
            borderRadius: '8px', 
            marginBottom: '16px' 
          }}>
            {error}
          </div>
        )}

        <form onSubmit={handleEmailAuth} className="login-form">
          <div className="form-group">
            <label className="form-label">
              <FiMail /> Email
            </label>
            <input
              type="email"
              className="form-input"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              required
              placeholder="your@email.com"
            />
          </div>

          <div className="form-group">
            <label className="form-label">
              <FiLock /> Password
            </label>
            <input
              type="password"
              className="form-input"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              required
              placeholder="••••••••"
            />
          </div>

          <button type="submit" className="btn btn-primary" style={{ width: '100%' }}>
            {isSignUp ? 'Sign Up' : 'Login'}
          </button>
        </form>

        <div className="login-divider">
          <span>OR</span>
        </div>

        <div className="social-login">
          <button onClick={handleGoogleSignIn} className="btn btn-secondary" style={{ width: '100%' }}>
            <FcGoogle /> Continue with Google
          </button>
        </div>

        <p style={{ textAlign: 'center', marginTop: '24px', color: '#757575' }}>
          {isSignUp ? 'Already have an account?' : "Don't have an account?"}{' '}
          <button 
            onClick={() => setIsSignUp(!isSignUp)}
            style={{ 
              background: 'none', 
              border: 'none', 
              color: '#4CAF50', 
              cursor: 'pointer',
              fontWeight: '600',
              textDecoration: 'underline'
            }}
          >
            {isSignUp ? 'Login' : 'Sign Up'}
          </button>
        </p>
      </div>
    </div>
  );
};

export default Login;

